var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThumbsupIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 16.5H13.5C14.1225 16.5 14.655 16.125 14.88 15.585L17.145 10.2975C17.2125 10.125 17.25 9.945 17.25 9.75V8.25C17.25 7.425 16.575 6.75 15.75 6.75H11.0175L11.73 3.3225L11.7525 3.0825C11.7525 2.775 11.625 2.49 11.4225 2.2875L10.6275 1.5L5.685 6.4425C5.415 6.7125 5.25 7.0875 5.25 7.5V15C5.25 15.825 5.925 16.5 6.75 16.5ZM6.75 7.50012L10.005 4.24512L9 8.25012H15.75V9.75012L13.5 15.0001H6.75V7.50012ZM3.75 7.5H0.75V16.5H3.75V7.5Z",
    fill: "#696F88"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsupIcon);
export default __webpack_public_path__ + "static/media/thumbsup_icon.6d98a3a9d8fd64781be27cadbd1c3e43.svg";
export { ForwardRef as ReactComponent };